import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/types';
import { initialState, IUser } from './user.redux';

const selectDomain = (state: RootState) => state?.user || initialState;

export const selectUser = createSelector([selectDomain], (userState: IUser) => userState);
